import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const voucher = [
    {
        path: baseUrlTenant,
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                path: "annual-voucher/:answer_id",
                name: "annual-voucher",
                component: () => import("@/view/pages/voucher/AnnualVoucher")
            },
            {
                path: "weekly-voucher/:answer_id",
                name: "weekly-voucher",
                component: () => import("@/view/pages/voucher/WeeklyVoucher")
            },
            {
                path: "voucher-search",
                name: "voucher-search",
                component: () => import("@/view/pages/voucher/Search")
            },
            {
                path: "voucher-register",
                name: "voucher-register",
                component: () => import("@/view/pages/voucher/Register")
            },
            {
                path: "detail-voucher-custom/:id_answer",
                name: "detail-voucher-custom",
                component: () => import("@/view/pages/voucher/RegisterDetail")
            }
        ]
    },
]

export default voucher
